/**
 * 模型中心路由配置
 * @description 模型相关路由
 */
import type { RouteRecordRaw } from 'vue-router'

const modelRoutes: RouteRecordRaw[] = [
  {
    path: '/models',
    name: 'ModelList',
    component: () => import('@/views/ModelList.vue'),
    meta: {
      title: '模型中心',
      requiresAuth: false,
      cache: false,
      breadcrumb: true,
      order: 2,
    },
  },
  {
    path: '/models/:id',
    name: 'ModelDetail',
    component: () => import('@/views/ModelDetail.vue'),
    meta: {
      title: '模型详情',
      requiresAuth: false,
      cache: false,
      breadcrumb: true,
      order: 3,
    },
  },
]

export default modelRoutes
